// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62537271","453":"10f7d543","455":"17a99d0a","977":"80b4a214"}[chunkId] + ".chunk.js";
};